import { createDraftSafeSelector } from '@reduxjs/toolkit';

import type { RootState } from '@app/redux/interface';

export const getMfaState = (state: RootState) => state.mfa;

export const getMFAPreconditionData = createDraftSafeSelector(getMfaState, mfaState => mfaState.mfaPreconditionData);

export const getavailableMFAMethods = createDraftSafeSelector(getMfaState, mfaState => mfaState.availableMFAMethods);

export const getRememberMe = createDraftSafeSelector(getMfaState, mfaState => mfaState.rememberMe);
